if (!customElements.get('paypal-paylater')) {
  customElements.define(
    'paypal-paylater',
    class PayPalPayLater extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.messageEl = this.querySelector('[data-pp-message]');
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data.variant;
          if (!variant || !this.messageEl) return;
          // Shopify prices are in cents — convert to currency units
          const amount = (variant.price / 100).toFixed(2);
          this.messageEl.setAttribute('data-pp-amount', amount);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
    }
  );
}
